import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./HomeGallery.css";

// ✅ All Images Imported
import c1 from "../../Assets/SelfDrive/Tharr.jpg";
import c2 from "../../Assets/SelfDrive/Fortuner.jpg";
import c3 from "../../Assets/SelfDrive/Scorpio N.jpg";
import c4 from "../../Assets/SelfDrive/Safari.jpg";
import c5 from "../../Assets/SelfDrive/xuv700.jpg";
import c6 from "../../Assets/SelfDrive/Innova Crysta.jpg";
import c7 from "../../Assets/SelfDrive/Kia Seltos.jpg";
import c8 from "../../Assets/SelfDrive/Hyundai Creta.jpg";

const carDetails = [
  {
    id: 1,
    src: c1,
    name: "Mahindra Thar 2025",
    status: "Available",
    price12: "₹3000",
    price24: "₹4500"
  },
  {
    id: 2,
    src: c2,
    name: "Toyota Fortuner",
    status: "Available",
    price12: "₹8000",
    price24: "₹11000"
  },
  {
    id: 3,
    src: c3,
    name: "Mahindra Scorpio N 2025",
    status: "Available",
    price12: "₹3500",
    price24: "₹5000"
  },
  {
    id: 4,
    src: c4,
    name: "Tata Safari",
    status: "Available",
    price12: "₹4000",
    price24: "₹6000"
  },
  {
    id: 5,
    src: c5,
    name: "Mahindra XUV700 2025",
    status: "Available",
    price12: "₹4500",
    price24: "₹6500"
  },
  {
    id: 6,
    src: c6,
    name: "Toyota Innova Crysta",
    status: "Available",
    price12: "₹3000",
    price24: "₹4500"
  },
  {
    id: 7,
    src: c7,
    name: "Kia Seltos",
    status: "Available",
    price12: "₹3000",
    price24: "₹4500"
  },
  {
    id: 8,
    src: c8,
    name: "Hyundai Creta 2025",
    status: "Available",
    price12: "₹3500",
    price24: "₹5000"
  }
];

const HomeGallery = () => {
  const navigate = useNavigate();
  const [activeId, setActiveId] = useState(null);

  const phoneNumber = "919755357721"; // ✅ Format for WhatsApp (91 followed by number)

  const handleWhatsApp = (e, carName) => {
    e.stopPropagation(); 
    const message = `Hello, I'm interested in booking the ${carName}. Please provide more details.`;
    window.location.href = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  };

  return (
    <section className="home-gallery-dark">
      <div className="gallery-header">
        <h2 className="gallery-title">
          Our <span>Premium</span> Fleet
        </h2>
        <p className="gallery-subtitle">Tap a vehicle to view booking options in Indore</p>
      </div>

      <div className="gallery-grid">
        {carDetails.map((car) => (
          <div 
            key={car.id} 
            className={`gallery-card ${activeId === car.id ? "active" : ""}`}
            onClick={() => setActiveId(activeId === car.id ? null : car.id)}
          >
            <div className={`status-badge ${car.status.toLowerCase()}`}>
              {car.status}
            </div>

            <div className="image-container">
               <img src={car.src} alt={car.name} className="gallery-img" />
            </div>
            
            <div className="gallery-overlay">
              <div className="overlay-info">
                <h3>{car.name}</h3>
                {/* ✅ Rates Added */}
                <div className="price-container" style={{ marginBottom: '10px' }}>
                  <p style={{ margin: '0' }}>12hrs: <b>{car.price12}</b></p>
                  <p style={{ margin: '0' }}>24hrs: <b>{car.price24}</b></p>
                </div>
                {/* ✅ WhatsApp Booking Button */}
                <button className="call-btn-dark" onClick={(e) => handleWhatsApp(e, car.name)}>
                  💬 Book on WhatsApp
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="view-all-wrapper">
        <button className="view-all-dark" onClick={() => navigate("/gallery")}>
          Explore Full Fleet Gallery →
        </button>
      </div>
    </section>
  );
};

export default HomeGallery;